<template>
  <div class="ErrorHistory">
    <template v-if="nowPage == '即時維修狀態'"><maintainStatus /></template>
    <template v-else-if="nowPage == '維修履歷'"><maintainLog /></template>
    <template v-else-if="nowPage == '警報履歷'"><alarmHistory /></template>
  </div>
</template>

<script>
// import $ from "jquery";
import maintainStatus from "@/components/maintainStatus.vue";
import maintainLog from "@/components/maintainLog.vue";
import alarmHistory from "@/components/alarmHistory.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ErrorHistory",
  data() {
    return {
      nowPage: "",
    };
  },
  created: function () {
    window.addEventListener("beforeunload", this.setSessionItems);
    let page = sessionStorage.getItem("error_log_page");
    if (page == "即時維修狀態") {
      this.set_sideBarSelect(["errorhistory", "maintainstatus"]);
    } else if (page == "維修履歷") {
      this.set_sideBarSelect(["errorhistory", "maintainlog"]);
    } else if (page == "警報履歷") {
      this.set_sideBarSelect(["errorhistory", "alarmhistory"]);
    } 

    sessionStorage.removeItem("error_log_page")
    this.change_selectPage("errorhistory");
    this.change_selectPageName(this.pageName.errorhistory);
  },
  mounted: function () {
  },
  components: {
    alarmHistory,
    maintainStatus,
    maintainLog
  },
  watch: {
    sideBarSelect: {
      handler() {
        let vm = this;
        vm.nowPage = vm.sideBarSelect.processName;
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      pageName: "getlogin/get_pageName",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect",
    }),
    setSessionItems() {
      sessionStorage.setItem("error_log_page", this.sideBarSelect.processName);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
  },
};
</script>

<style scoped>
</style>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/views/ErrorHistory.vue